import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { QUERY_KEYS } from './queryKeys';

export interface Equipment {
    id: number;
    code: string;
    name: string;
    category: 'drilling' | 'loading' | 'transport' | 'support';
    brand: string;
    model: string;
    status: 'operational' | 'maintenance' | 'out_of_service';
    hours_operated: number;
    last_maintenance?: string;
    is_active: boolean;
}

export interface Part {
    id: number;
    code: string;
    description: string;
    stock_quantity: number;
    in_stock: boolean;
}

const fetchEquipmentList = async (filters?: any): Promise<Equipment[]> => {
    const { data } = await api.get(API_ROUTES.equipment, { params: filters });
    return data;
};

export const useEquipmentList = (filters?: any) => {
    return useQuery({
        queryKey: QUERY_KEYS.equipment.list(filters),
        queryFn: () => fetchEquipmentList(filters),
    });
};

const fetchParts = async (): Promise<Part[]> => {
    const { data } = await api.get(API_ROUTES.parts);
    return data;
};

export const useParts = () => {
    return useQuery({
        queryKey: ['parts'],
        queryFn: fetchParts,
    });
};
